import {slideUp, slideDown} from 'es6-slide-up-down';
import findAncestor from "./findAncestor";

export default () => {
    const header = document.querySelector('[data-header]');
    const hamburger = document.querySelector('[data-hamburger]');
    const navigation = document.querySelector('[data-navigation]');
    const subNavigationItems = document.querySelectorAll('[data-subnav]');

    function stickyNavClass() {
        if (window.scrollY > 220) {
            header.classList.add('stick');
        } else {
            header.classList.remove('stick');
        }
    }


    if (hamburger) {
        hamburger.addEventListener('click', (e) => {
            e.preventDefault();
            if (hamburger.classList.contains('active')) {
                hamburger.classList.remove('active');
                navigation.classList.remove('active');
            } else {
                hamburger.classList.add('active');
                navigation.classList.add('active');
            }
            return false;
        });
    }

    for (const item of subNavigationItems) {

        item.addEventListener('click', (e) => {
                e.preventDefault();
                const parent = findAncestor(item, 'li');
                const subNav = parent.querySelector('ul');
                if (subNav.classList.contains('active')) {
                    slideUp(subNav, 500);
                    subNav.classList.remove('active');
                    item.classList.remove('active')
                } else {
                    slideDown(subNav, 500);
                    subNav.classList.add('active');
                    item.classList.add('active')
                }
                return false;
           return true;
        });

    }

    window.addEventListener('scroll', () => {
        stickyNavClass();
    });

}
